import type React from 'react';
import type { ReactNode } from 'react';
import { Helmet } from 'react-helmet';

const HelmetComponent = Helmet as unknown as React.FC<{ children: ReactNode }>;

const HtmlTitle = ({ title }: { title: string }): ReactNode => (
  <HelmetComponent>
    <title>{title} | HYROX365 Performance Hub</title>
  </HelmetComponent>
);

export default HtmlTitle;
